import styled from 'styled-components';
import { PaginationItem } from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import { modeProperty } from '../Theme/modeProperty';

export const StyledButton = styled(Button)`
  margin-left: 1rem;
  height: 2rem;
  position: relative;
  border-radius: 0.3rem;
  ${({ theme }) => theme.breakpoints.down('xs')} {
    order: -1;
    margin-bottom: 1rem;
  }
`;

export const StyledSelect = styled.select`
  appearance: none;
  width: 100%;
  height: 100%;
  background: transparent;
  border-radius: inherit;
  border: none;
  color: inherit;
  font-family: inherit;
  outline: none;
  padding-left: 0;
  padding-right: 1rem;
  text-align-last: center;
  min-width: 40px;
`;

export const StyledIcon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CountContainer = styled.div`
  font-family: ${({ theme }) => theme.secondFont};
  color: ${({ theme }) => theme.colorLight};
  margin-right: auto;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    order: -1;
    margin-bottom: 1rem;
    flex: 60%;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  .MuiPaginationItem-ellipsis {
    color: ${({ theme }) => theme.colorMain};
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    justify-content: center;
    padding: 1.5rem;
    /* ${modeProperty('light', 'border', (theme) => `1px solid ${theme.borderColor}`)}; */
    border-radius: 0.625rem;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0 1rem;
    border: none;
    background: transparent;
    margin-top: 1rem;
    flex-wrap: wrap;
  }
`;

export const StyledPaginationItem = styled(PaginationItem)`
  ${({ type }) => type === 'page' && `border: none`};
  border-radius: 0.2rem;
  border-color: ${({ theme }) => theme.borderColor};
  font-family: ${({ theme }) => theme.secondFont};
  font-weight: normal;
  font-size: 1rem;
  color: ${({ theme, selected }) => (selected ? theme.colorMain : theme.colorLight)};
  &.Mui-selected {
    background: transparent;
    font-weight: bold;
  }
`;
